import { render, staticRenderFns } from "./reduceDetial.vue?vue&type=template&id=04cde1ae&scoped=true"
import script from "./reduceDetial.vue?vue&type=script&lang=js"
export * from "./reduceDetial.vue?vue&type=script&lang=js"
import style0 from "./reduceDetial.vue?vue&type=style&index=0&id=04cde1ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cde1ae",
  null
  
)

export default component.exports